const W = "https://kataco.ro/wp-content/uploads";

export const DISMANTLING = [
  {
    id: "alfa-romeo-156",
    title: "Alfa Romeo 156 1.8i Spark",
    year: 1999,
    engine: "1747 cmc / 106 kW",
    fuel: { en: "Petrol", ro: "Benzină" },
    km: null,
    price: 850,
    desc: {
      en: "Sold whole or dismantled for parts. Electric windows, electric mirrors, radio-CD, air conditioning, central locking.",
      ro: "Se vinde întreg sau se dezmembrează. Geamuri electrice, oglinzi electrice, radio-CD, aer condiționat, închidere centralizată.",
    },
    images: [7, 1, 2, 3, 4, 5, 6].map((n) => `${W}/2022/05/8110272_alfa-romeo-156-18-i-spark_${n}.jpg`),
  },
  {
    id: "citroen-jumpy-frigorific",
    title: "Citroën Jumpy Frigorific",
    year: 2007,
    engine: "1868 cmc",
    fuel: { en: "Diesel", ro: "Diesel" },
    km: 110000,
    price: null,
    desc: {
      en: "Two units available. Insulated refrigerated body with cooling unit, manual gearbox, Euro 4, white, first registered June 2007, France.",
      ro: "Două unități disponibile. Caroserie frigorifică (izotermă) cu agregat frigorific, cutie manuală, Euro 4, alb, prima înmatriculare iunie 2007, Franța.",
    },
    images: [2, 1, 3, 4].map((n) => `${W}/2022/08/2431981_citroen-jumpy-frigorific-2-bucati_${n}.jpg`),
  },
  {
    id: "cutie-remorca-kogel-awe-18",
    title: "Cutie Remorcă Kögel AWE 18",
    year: null,
    engine: null,
    fuel: null,
    km: null,
    price: 1499,
    desc: {
      en: "Kögel AWE 18 trailer box — available complete or for parts.",
      ro: "Cutie de remorcă Kögel AWE 18 — disponibilă întreagă sau pe piese.",
    },
    images: [`${W}/2022/09/c897e805-5549-4f4e-8a00-4f8bfe4dc1d8.jpg`],
  },
  {
    id: "fiat-punto-176",
    title: "Fiat Punto 176",
    year: 1999,
    engine: null,
    fuel: null,
    km: 220000,
    price: 699,
    desc: {
      en: "The car runs perfectly — available for dismantling or to be put back on the road.",
      ro: "Mașina funcționează perfect — se poate lua pentru dezmembrare sau pentru a se pune în circulație.",
    },
    images: [3, 1, 2, 4].map((n) => `${W}/2022/08/12680170_fiat-punto-176_${n}.jpg`),
  },
  {
    id: "nissan-terrano",
    title: "Nissan Terrano",
    year: null,
    engine: null,
    fuel: null,
    km: null,
    price: null,
    desc: {
      en: "Nissan Terrano available for dismantling — body, engine and interior parts on request.",
      ro: "Nissan Terrano disponibil pentru dezmembrare — piese de caroserie, motor și interior la cerere.",
    },
    images: [
      `${W}/2022/08/31ffdaf2-b35c-46bb-bf77-e0bb8cccf348.jpg`,
      `${W}/2022/08/110ff410-c265-403d-a5ab-3a0356e0435c.jpg`,
      `${W}/2022/08/d3c5fc52-fd5e-4c0d-93f7-eefd075b6657.jpg`,
    ],
  },
  {
    id: "nissan-terrano-2000",
    title: "Nissan Terrano 2.8 Diesel",
    year: 2000,
    engine: "2.8 Diesel",
    fuel: { en: "Diesel", ro: "Diesel" },
    km: null,
    price: 1499,
    desc: {
      en: "Currently dismantling a Nissan Terrano 2 with the 2.8 diesel engine. Whole car also available.",
      ro: "Dezmembrăm Nissan Terrano 2, motor 2.8 diesel. Mașina este disponibilă și întreagă.",
    },
    images: [1, 2].map((n) => `${W}/2022/08/91202_nissan-terano-2-model-2000_${n}.jpg`),
  },
  {
    id: "smart-fortwo",
    title: "Smart Fortwo",
    year: 2001,
    engine: "600 cmc",
    fuel: { en: "Petrol", ro: "Benzină" },
    km: 142000,
    price: 600,
    desc: {
      en: "Smart Fortwo available for dismantling, 600 cmc petrol engine.",
      ro: "Smart Fortwo disponibil pentru dezmembrare, motor 600 cmc benzină.",
    },
    images: [`${W}/2022/08/4579372_smart-fortwo-pentru-dezmembrare_4.jpg`],
  },
  {
    id: "usi-autoutilitare",
    title: "Uși Autoutilitare Iveco / Opel / Citroën / Fiat",
    year: null,
    engine: null,
    fuel: null,
    km: null,
    price: null,
    desc: {
      en: "Doors for Iveco, Opel, Citroën and Fiat vans — various models, good condition.",
      ro: "Uși pentru autoutilitare Iveco, Opel, Citroën și Fiat — diverse modele, stare bună.",
    },
    images: [11, 2, 4, 10, 12, 13, 14, 15, 16].map((n) => `${W}/2022/05/5462135_usi-autoutilitare-iveco-citroen-fiat_${n}.jpg`),
  },
];
